/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespMainContent_viewer = {
    readonly isContentModuleEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_viewer" | "SbRespSearchResultContainer_viewer" | "SbSharedRelatedItems_viewer">;
    readonly " $refType": "SbRespMainContent_viewer";
};
export type SbRespMainContent_viewer$data = SbRespMainContent_viewer;
export type SbRespMainContent_viewer$key = {
    readonly " $data"?: SbRespMainContent_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespMainContent_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespMainContent_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isContentModuleEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "BROWSE_CONTENT_MODULES"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"BROWSE_CONTENT_MODULES\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '8f59c9ae31fea54a201cc22452da6e7e';
export default node;
